import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NotificationsService } from '@app/core';
import { NewsletterService } from '@app/domains/newsletter/services';
import { SharedModule } from '@app/shared';
import {
  TuiButton,
  TuiError,
  TuiGroup,
  TuiLabel,
  TuiTextfield,
} from '@taiga-ui/core';
import {
  TuiButtonLoading,
  TuiCheckbox,
  TuiFieldErrorPipe,
} from '@taiga-ui/kit';

@Component({
  selector: 'app-newsletter-section',
  imports: [
    SharedModule,
    TuiButton,
    TuiButtonLoading,
    TuiCheckbox,
    TuiError,
    TuiFieldErrorPipe,
    TuiGroup,
    TuiLabel,
    TuiTextfield,
  ],
  templateUrl: './newsletter-section.component.html',
  styleUrl: './newsletter-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewsletterSectionComponent {
  protected readonly formGroup = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    terms: new FormControl(false, [Validators.requiredTrue]),
  });
  protected readonly subscribeNewsletter = this.newsletterService.subscribe();

  constructor(
    private readonly newsletterService: NewsletterService,
    private readonly notificationsService: NotificationsService,
  ) {}

  protected async onSubmit(): Promise<void> {
    this.formGroup.markAllAsTouched();
    if (this.formGroup.invalid) {
      return;
    }
    if (!this.formGroup.value.email) {
      return;
    }
    await this.subscribeNewsletter.mutateAsync({
      email: this.formGroup.value.email,
    });
    void this.notificationsService.showSuccessNotification(
      'You have successfully subscribed to the newsletter!',
    );
    this.formGroup.reset({
      email: '',
      terms: false,
    });
  }
}
